export default {
  title: 'Älä jää paitsi!',
  description: 'Ota ilmoitukset käyttöön pysyäksesi ajan tasalla tilauksestasi.',
  buttons: {
    enable: 'Ota käyttöön',
  },
};
